import React from "react"
import { EApproveType, IExpenseDocument, IObjectAudit, IExpensesPayrollData } from "../../models"
import moment from "moment"
import ApprovedIcon from "./ApprovedIcon"
import strings from "../../localization/strings"
interface IProps {
	identify: string
	width: number
	toolTipPosition: "top" | "right" | "left" | "bottom"
	toolTipArrow: "center" | "right" | "left" | "top" | "bottom"
	approvalType: EApproveType.EmployeeApproved | EApproveType.SupervisorApproved
	expenses: (IExpenseDocument | IExpensesPayrollData)[]
}
interface IState {
	open: boolean
	latestApprovalAudit: IObjectAudit
}

export default class ExpensesApproveIconTooltip extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			open: false,
			latestApprovalAudit: null
		}
	}

	componentDidMount() {
		this.setState({ latestApprovalAudit: this.getLatestApprovalAudit() })
	}

	getLatestApprovalAudit() {
		let latestApproveDateTime = moment("2000-01-01").format()
		this.props.expenses.forEach(item => {
			if (this.props.approvalType === EApproveType.EmployeeApproved && item.EmployeeApproved && moment(latestApproveDateTime).isBefore(moment(item.EmployeeApprovalAudit.LastModified))) {
				latestApproveDateTime = item.EmployeeApprovalAudit.LastModified as string
			}
			else if (this.props.approvalType === EApproveType.SupervisorApproved && item.SupervisorApproved && moment(latestApproveDateTime).isBefore(moment(item.SupervisorApprovalAudit.LastModified))) {
				latestApproveDateTime = item.SupervisorApprovalAudit.LastModified as string
			}
		})

		const latestApprovedExpenses = this.props.expenses.find(item =>
			this.props.approvalType === EApproveType.EmployeeApproved ?
				item.EmployeeApprovalAudit && item.EmployeeApprovalAudit.LastModified === latestApproveDateTime :
				item.SupervisorApprovalAudit && item.SupervisorApprovalAudit.LastModified === latestApproveDateTime
		)
		return this.props.approvalType === EApproveType.EmployeeApproved ?
			latestApprovedExpenses.EmployeeApprovalAudit :
			latestApprovedExpenses.SupervisorApprovalAudit
	}

	render() {
		return (
			<ApprovedIcon
				keyStr={`${this.props.approvalType === EApproveType.SupervisorApproved ? "supervisor" : "employee"}_${this.props.identify}`}
				label={this.props.approvalType === EApproveType.SupervisorApproved ? strings.Supervisor_Approved : strings.Employee_Approved}
				audit={this.state.latestApprovalAudit}
			/>
		)
	}
}